import Api from 'core/services/api'
import { ConsentPublishRequest } from 'core/services/models'

const path = '/v1'

export const consentPublish = (params: ConsentPublishRequest) => {
  return Api.post(`${path}/consents`, params)
}
